define.alias("shared/components/shared/pre-boarding/context-modal/side-plan-card", "calendar/components/shared/pre-boarding/context-modal/side-plan-card");